import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import type {
  CancellationModel,
  CancellationState,
} from 'state/secondaryMarket/shared/cancellation/cancellation.model';
import type { AppState } from 'state/state.model';

export const cancellationSelectorsFactory = (stateType: SecondaryOrderStatePath) => {
  const selectOrderCancellationsState = (state: AppState): CancellationState =>
    state.secondaryMarket[stateType].cancellations;
  return {
    selectOrderCancellationsState,
    getOrderCancellation: (appState: AppState, orderId: string): CancellationModel | undefined =>
      selectOrderCancellationsState(appState)[orderId],
  };
};

export type CancellationSelectors = ReturnType<typeof cancellationSelectorsFactory>;
